function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useMemo, useRef } from 'react';
import { useCombineCallback, useUpdate } from '@bydesign-ui/hooks';
import { classnames } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { RcPopper } from '../../hooks/popper';
import { RcAutoCompleteProvider, useSingleAutoComplete } from '../../hooks/autocomplete';
import { AutoCompleteMain } from './AutoCompleteMain';
export function AutoComplete(props) {
  var className = props.className,
      style = props.style,
      value = props.value,
      dataSource = props.dataSource,
      renderSearchItem = props.renderSearchItem,
      _props$invalid = props.invalid,
      invalid = _props$invalid === void 0 ? false : _props$invalid,
      disabled = props.disabled,
      filterOption = props.filterOption,
      allowClear = props.allowClear,
      _props$showEmpty = props.showEmpty,
      showEmpty = _props$showEmpty === void 0 ? false : _props$showEmpty,
      onChange = props.onChange,
      onValueChange = props.onValueChange,
      onSelect = props.onSelect,
      onSearch = props.onSearch,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      extra = _objectWithoutProperties(props, ["className", "style", "value", "dataSource", "renderSearchItem", "invalid", "disabled", "filterOption", "allowClear", "showEmpty", "onChange", "onValueChange", "onSelect", "onSearch", "onBlur", "onFocus"]);

  var focusedRef = useRef(false);
  var showRef = useRef(false);
  var update = useUpdate();
  var onDetectFocus = useCallback(function () {
    if (!disabled) {
      focusedRef.current = true;
      !showRef.current && update();
    }
  }, []);
  var onDetectBlur = useCallback(function () {
    focusedRef.current = false;
    showRef.current && update();
  }, []);
  var onFocusCallBack = useCombineCallback(onFocus, onDetectFocus);
  var onBlurCallBack = useCombineCallback(onBlur, onDetectBlur);
  var handleChange = useCombineCallback(onValueChange, onChange);
  var root = useSingleAutoComplete({
    showEmpty: showEmpty,
    disabled: disabled,
    value: value,
    onHide: onDetectBlur,
    onSearch: onSearch,
    onSelect: onSelect,
    onChange: handleChange,
    allowClear: allowClear,
    dataSource: dataSource,
    filterOption: filterOption,
    renderSearchItem: renderSearchItem
  });
  var show = useMemo(function () {
    if (focusedRef.current) {
      return showEmpty ? true : Boolean(root.getFilterData().length);
    }

    return false;
  }, [focusedRef.current, showEmpty, root.getFilterData().length]);
  showRef.current = show;
  var autoCompleteCls = classnames(usePrefixCls('auto-complete', {
    warning: invalid
  }), className);
  return React.createElement(RcAutoCompleteProvider, {
    root: root
  }, React.createElement(RcPopper, null, React.createElement("div", {
    className: autoCompleteCls,
    style: style
  }, React.createElement(AutoCompleteMain, Object.assign({
    show: show,
    onFocus: onFocusCallBack,
    onBlur: onBlurCallBack
  }, extra)))));
}